<template>
	<div class="page">
		<video ref="vid" playsInline autoplay="autoplay" muted loop>
			<source v-if="$root.isMobile" src="/videos/mobile_stars.mp4" type="video/mp4">
			<source v-else src="/videos/desktop_stars.mp4" type="video/mp4">
			Your browser does not support the video tag.
		</video>
		<h1>Tell us what keeps<br>you up at night</h1>
		<div class="page-inner">
			<transition name="bounce">
				<div v-if="bounce" :class="['button-container', {'button-bounce': buttonpressed === 1}, {'button-pulse': buttonpulse}]">
					<button class="button1" @click="selectAnswer(1)">
						
					</button>
					<div class="button-title">I’m feeling stuck in<br>a rut</div>
				</div>
			</transition>
			<transition name="bounce">
				<div v-if="bounce" :class="['button-container', {'button-bounce': buttonpressed === 2}, {'button-pulse': buttonpulse}]">
					<button class="button2" @click="selectAnswer(2)">
						
					</button>
					<div class="button-title">Reshaping my career or the way I work</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			signedIn: localStorage.getItem("spotifyAuthCode"),
			bounce: false,
			buttonpressed: false,
			buttonpulse: true,
		}
	},
	mounted() {
		setTimeout(() => {
			this.bounce = true;
		}, 200)
	},
	methods: {
		selectAnswer(choice) {
			this.buttonpulse = false;
			this.buttonpressed = choice;
			choice === 1 
			? this.gaEvent('What Keeps You Up Quiz', 'Clicked Stuck in a Rut')
			: this.gaEvent('What Keeps You Up Quiz', 'Clicked Reshaping my Career')

			localStorage.setItem("sleepstory", choice);
			setTimeout(() => {
				this.buttonpressed = false;
				this.$router.push({ name: this.signedIn ? '5' : '4' })
			}, 400)
		}
	}
};
</script>

<style scoped>
.page {
	overflow: hidden;
	height: 100vh;
}

h1 {
	z-index: 1;
    position: absolute;
    width: 100%;
    margin-top: 6rem;
}

.page-inner {
    justify-content: center;
}

.desktop .page-inner {
	flex-flow: wrap;
}

.button-title {
	margin: auto;
	font-size: 2.5rem;
}

button {
	display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    border-radius: 1rem;
	box-shadow: 0px 2px 3px 0px grey;
    margin: 2rem 2rem 1rem;
    height: 15rem;
    width: 22rem;
	background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.mobile button {
	height: 9rem;
	width: 16rem;
}

.desktop .button-container {
	display: flex;
	justify-content: center;
}

.desktop .button-title {
    position: absolute;
    transform: translateY(18rem);
}

.button1 {
    background-image: url(/images/wheel.gif);
}
/* .button1 {
	background-image: url(/images/wheel.png);
} */
.button2 {
	background-image: url(/images/reshaping.gif);
}
/* .button2 {
    background-image: url(/images/reshaping.jpg);
} */
</style>
